import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../../../../../hooks/use-toast";
import { imileFechamentoService } from "../services/imile-fechamento-service";

/**
 * Dois hooks, contra os nove de use-controle-nfs do entrego: a tela da iMile tem
 * só o status da quinzena e o disparo de e-mails. Parametrizar o endpoint num
 * hook compartilhado arrastaria os outros sete (NFS, ZIP, saldo remanescente)
 * para uma tela que não os tem — por isso é cópia, não generalização.
 *
 * queryKey própria ("imile-fechamento"), senão o react-query serviria o cache
 * do fechamento do entrego.
 */
export const imileFechamentoKeys = {
  all: ["imile-fechamento"] as const,
  status: () => [...imileFechamentoKeys.all, "status"] as const,
};

export const useImileFechamentoStatus = () =>
  useQuery({
    queryKey: imileFechamentoKeys.status(),
    queryFn: async () => {
      const response = await imileFechamentoService.getFechamentoStatus();
      return response.data;
    },
  });

export const useEnviarEmailImileFechamento = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: imileFechamentoService.enviarEmailFechamento,
    onSuccess: (response) => {
      const data = response.data;
      // O backend se recusa a enviar com a quinzena incompleta e devolve 200 com
      // quinzena_completa=false. Sem este ramo a tela diria "enviado com sucesso"
      // para um envio que não aconteceu.
      if (data?.quinzena_completa === false) {
        toast({
          title: "Aviso",
          description: "A quinzena ainda não está completa — email não enviado.",
        });
      } else {
        const n = data?.emails_enviados;
        toast({
          title: "Sucesso",
          description:
            n != null
              ? `Fechamento enviado: ${n} e-mail(s), um por franquia.`
              : "Email de fechamento enviado com sucesso!",
        });
      }
      queryClient.invalidateQueries({ queryKey: imileFechamentoKeys.status() });
    },
    onError: () => {
      toast({
        title: "Erro",
        description: "Erro ao enviar email de fechamento",
        variant: "destructive",
      });
    },
  });
};
